import type { AutocompleteItem } from '../types';

export function buildShowIdentifier(show: AutocompleteItem): string {
  const showAny = show as unknown as Record<string, unknown>;
  const identifier =
    showAny.dbId ??
    showAny.opsubsId ??
    showAny.opSubsId ??
    showAny.tmdbId ??
    showAny.imdbId ??
    showAny.id ??
    showAny.value ??
    showAny.key;

  return identifier ? String(identifier) : '';
}

export function isYoutubeShow(show: Partial<AutocompleteItem> | null | undefined): boolean {
  if (!show) {
    return false;
  }
  const title = `${show.title || ''}`.toLowerCase();
  const originalTitle = `${show.originalTitle || ''}`.toLowerCase();
  return title.startsWith('yt:') || originalTitle.startsWith('youtube:');
}

export function collectShowIdentifiers(
  show: Partial<AutocompleteItem> | null | undefined,
  extras: Array<string | number | null | undefined> = []
): string[] {
  const ids: Array<string | number | null | undefined> = [];
  const showAny = (show || {}) as Record<string, unknown>;

  ids.push(
    showAny.dbId as string | number | undefined,
    showAny.opsubsId as string | number | undefined,
    showAny.opSubsId as string | number | undefined,
    showAny.tmdbId as string | number | undefined,
    showAny.imdbId as string | number | undefined,
    showAny.id as string | number | undefined,
    showAny.value as string | number | undefined,
    showAny.key as string | number | undefined
  );
  ids.push(...extras);

  const normalized = new Set<string>();
  for (const value of ids) {
    if (value === null || typeof value === 'undefined') {
      continue;
    }
    const str = String(value).trim();
    if (!str) {
      continue;
    }
    normalized.add(str);
  }

  return Array.from(normalized);
}

export function extractYoutubeVideoId(show: Partial<AutocompleteItem> | null | undefined): string | null {
  if (!show) {
    return null;
  }
  const title = `${show.title || ''}`.trim();
  const match = title.match(/^yt:([A-Za-z0-9_-]{11})$/);
  if (match?.[1]) {
    return match[1];
  }
  return null;
}
